import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import pt from 'vuetify/lib/locale/pt';

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#4b1441',
                secondary: '#209a90',
                accent: '#8c9eff',
                error: '#b71c1c',
            },
        },
    },

    lang: {
        locales: {pt},
        current: 'pt',
    },
})



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js